import React from 'react';
import styled from 'styled-components';

interface Props {
	name: string;
	className?: string;
	onClick?: () => void;
}

const ClickableIcon = styled.button`
`

export const Icon: React.FC<Props> = (props: Props) => {
	const className = `svg-icon svg-${props.name} svg-${props.name}-dims ${props.className ? props.className : ''}`;
	if (props.onClick) {
		return (
			<ClickableIcon className={props.className} onClick={props.onClick}>
				<span className={className} />
			</ClickableIcon>
		)
	}
	return (
		<span className={className} />
	)
};